var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 10,
    fill: "#1E2D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_4925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.25 23.1428L28.75 26.5714H25.25L22.1875 29.5714V26.5714H18.25V13.7142H32.25V23.1428Z",
    fill: "#1E2D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 12L13 16.2857V31.7143H18.25V36L22.625 31.7143H26.125L34 24V12H17.375ZM32.25 23.1429L28.75 26.5714H25.25L22.1875 29.5714V26.5714H18.25V13.7143H32.25V23.1429Z",
    fill: "#546A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.625 16.7142H27.875V21.8571H29.625V16.7142Z",
    fill: "#546A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 16.7142H23.0625V21.8571H24.8125V16.7142Z",
    fill: "#546A7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_4925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchSquare);
export default __webpack_public_path__ + "static/media/twitchSquare.a592c81e51ef1ab2fe3eddb35f8cff1a.svg";
export { ForwardRef as ReactComponent };